"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Queue = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Queue = /*#__PURE__*/function () {
  function Queue() {
    (0, _classCallCheck2["default"])(this, Queue);
    (0, _defineProperty2["default"])(this, "lock", void 0);
    (0, _defineProperty2["default"])(this, "list", void 0);
    this.lock = false;
    this.list = [];
  }

  (0, _createClass2["default"])(Queue, [{
    key: "call",
    value: function () {
      var _call = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(callback) {
        var _this = this;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", new Promise(function (resolve, reject) {
                  _this.list.push([callback, resolve, reject]);

                  _this.runQueue();
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function call(_x) {
        return _call.apply(this, arguments);
      }

      return call;
    }()
  }, {
    key: "runQueue",
    value: function runQueue() {
      var _this2 = this;

      if (this.lock) {
        return;
      }

      var job = this.list.shift();

      if (!job) {
        return;
      }

      this.lock = true;

      var _job = (0, _slicedToArray2["default"])(job, 3),
          callback = _job[0],
          resolve = _job[1],
          reject = _job[2];

      callback().then(function (res) {
        resolve(res);

        _this2.restartQueue();
      })["catch"](function (e) {
        reject(e);

        _this2.restartQueue();
      });
    }
  }, {
    key: "restartQueue",
    value: function restartQueue() {
      this.lock = false;
      this.runQueue();
    }
  }]);
  return Queue;
}();

exports.Queue = Queue;